<template>
  <DxDataGrid
    :data-source="localData.contact_person_data"
    :showBorders="true"
    ref="partnerBankGrid"
    :element-attr="gridAttributes"
    key-expr="uuid"
  >
    <DxColumn
      dataField="name"
      :caption="$t('stock_management.partners.contact.name')"
    >
      <DxRequiredRule :message="$t('validation.field_is_required')" />
    </DxColumn>
    <DxColumn
      dataField="address"
      :caption="$t('common.address')"
    >
    </DxColumn>
    <DxColumn
      dataField="phone"
      :caption="$t('common.phone')"
    >
    </DxColumn>
    <DxColumn
      dataField="email"
      :caption="$t('common.e_mail')"
    >
      <!-- Custom rule to validate email format if not empty -->
      <DxCustomRule
        :validation-callback="validateEmail"
        :message="$t('validation.invalid_email')"
      />
    </DxColumn>
    <DxColumn
      dataField="notes"
      :caption="$t('common.notes')"
    >
    </DxColumn>
    <DxEditing
      mode="form"
      :allowUpdating="true"
      :allowAdding="true"
      :allowDeleting="true"
      :use-icons="true"
    >
      <DxTexts
        :confirm-delete-message="
          $t('common.confirm_delete', {
            title: $t('common.contact_person'),
          })
        "
        :confirm-delete-title="$t('common.confirm_delete_title')"
        :save-row-changes="$t('common.save')"
        :cancel-row-changes="$t('common.close')"
        :addRow="$t('common.add_new')"
        :editRow="$t('common.edit')"
        :deleteRow="$t('common.delete')"
      />
    </DxEditing>
    <DxHeaderFilter :visible="false" />
    <DxFilterRow
      :visible="false"
      :showOperationChooser="true"
      apply-filter="auto"
    />
    <DxSelection mode="single" />
  </DxDataGrid>
</template>

<script>
import DxDataGrid, {
  DxColumn,
  DxEditing,
  DxHeaderFilter,
  DxFilterRow,
  DxSelection,
  DxTexts,
  DxRequiredRule,
  DxCustomRule,
} from "devextreme-vue/data-grid";
import { email } from "vuelidate/lib/validators";

export default {
  name: "PartnerContactPersons",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxHeaderFilter,
    DxFilterRow,
    DxSelection,
    DxTexts,
    DxRequiredRule,
    DxCustomRule,
  },
  data() {
    return {
      gridAttributes: {
        class: "partner-contact-person-grid",
      },
      localData: { ...this.data }, // Create a local copy of data
    };
  },
  computed: {},
  methods: {
    validate() {
      return true;
    },
    validateEmail(e) {
      if (!e.value) {
        return true; // Allow empty values
      }

      return email(e.value); // Use Vuelidate's email validator
    },
    updateData(newData) {
      if (JSON.stringify(this.localData) !== JSON.stringify(newData)) {
        console.log("updateData step 5 ", newData);
        this.localData = { ...newData }; // Update localData with new data
      }
    },
  },
  mounted() {},
  watch: {
    localData: {
      deep: true,
      handler(newData) {
        this.$emit("update-partner-data", newData, 5); // Emit updated data to parent
      },
    },
  },
};
</script>
